
import { EfficiencyChart } from "@/components/charts/EfficiencyChart";
import { PerformanceChart } from "@/components/charts/PerformanceChart";
import { TopStakers } from "./TopStakers";
import { useHourlyStats } from "@/hooks/useHourlyStats";
import { format, parseISO } from "date-fns";

interface NetworkGraphsProps {
  address?: string;
}

export function NetworkGraphs({ address }: NetworkGraphsProps) {
  const { data: hourlyStats, isLoading } = useHourlyStats(address, 24);

  // If no specific address is provided, only show TopStakers
  if (!address) {
    return (
      <div className="flex justify-center">
        <TopStakers />
      </div>
    );
  }

  // Format data for the efficiency chart
  const efficiencyData = hourlyStats?.map(stat => {
    // Ensure we have a valid date object
    const date = typeof stat.timestamp === 'string' ? parseISO(stat.timestamp) : new Date(stat.timestamp);
    
    return {
      date: stat.timestamp, // Store raw date
      displayDate: format(date, 'HH:mm'), // Format for clean time display
      value: stat.efficiency_score || 0,
      rank: stat.rank || 0,
      address: stat.address
    };
  }) || [];

  // Format data for the performance chart
  const performanceData = hourlyStats?.map(stat => {
    // Ensure we have a valid date object
    const date = typeof stat.timestamp === 'string' ? parseISO(stat.timestamp) : new Date(stat.timestamp);
    
    return {
      date: stat.timestamp, // Store raw date
      displayDate: format(date, 'HH:mm'), // Format for display
      value: stat.total_reward_change || 0,
      rank: stat.rank || 0,
    };
  }) || [];

  return (
    <div className="space-y-4 mt-8">
      <div className="w-full">
        <EfficiencyChart 
          data={efficiencyData}
          tooltipContent="Node efficiency score and ranking based on rewards earned over the last 24 hours"
        />
      </div>
      <div className="w-full mt-4">
        <PerformanceChart 
          title="Node Rewards"
          data={performanceData}
          tooltipContent="Node rewards earned per hour over the last 24 hours"
        />
      </div>
      <div className="flex justify-center">
        <TopStakers />
      </div>
    </div>
  );
}
